import React from 'react';
import * as Sentry from '@sentry/browser';

import Error from '@atlaskit/icon/glyph/error';
import Flag from '@atlaskit/flag';

import AppContainer from '../AppContainer';

import * as S from './styled';


class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <S.Error>
          <Flag
            id="1"
            key="1"
            actions={[
              {
                content: 'Clear local storage. It may help!',
                onClick: () => {
                  localStorage.clear();
                  window.location.reload();
                },
              },
            ]}
            description="We already got a report with the error and soon we will fix it."
            icon={(
              <Error
                label="Error"
              />
            )}
            title="Something wrong!"
          />
        </S.Error>
      );
    }
    return (
      <AppContainer />
    );
  }
}

export default AppErrorBoundary;
